import { AType, summon } from "@silversea-ssc/functional-support"

export const VsOption = summon((F) =>
    F.interface(
        {
            type: F.stringLiteral("VS"),
            percentage: F.number(),
        },
        "VsOption",
    ),
)
export type VsOption = AType<typeof VsOption>
